"use client";
import React, { useState, useEffect } from "react";

export default function CalculatorModal({ row, sectionKey, field, onUpdateRow }) {
  // Keep `times` as a string so the input can be cleared (empty string)
  // Start empty so the modal's Total is driven by the calculator inputs only
  const [times, setTimes] = useState("");
  const [period, setPeriod] = useState("yearly");
  const [open, setOpen] = useState(false);
  const [frequency, setFrequency] = useState(0);

  // Initialize values and handle updates
  useEffect(() => {
    if (open) {
      // Leave `times` empty on open so Total is produced from calculator inputs
      setFrequency(0);
    }
  }, [open]);

  // Recalculate frequency whenever inputs change (only local state, not parent)
  useEffect(() => {
    let multiplier = 1;
    if (period === "weekly") multiplier = 52;
    else if (period === "monthly") multiplier = 12;
    else if (period === "daily") multiplier = 365;
    else if (period === "yearly") multiplier = 1;

    const numericTimes = times === "" ? 0 : Number(times);
    const freq = Math.round(multiplier * (isNaN(numericTimes) ? 0 : numericTimes));
    setFrequency(freq);
  }, [times, period]);

  const updateFrequency = () => {
    const valueToSave = times === "" ? "" : Math.round(frequency);
    onUpdateRow({ ...row, [field]: valueToSave });
    setOpen(false);
  };

  return (
    <div>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
        className="mt-1 text-blue-500"
      >
        <img src="/mdi_calculator.svg" alt="calculator" className="w-5 h-5" />
      </button>

      {open && (
        <div onClick={(e) => e.stopPropagation()} className="absolute right-[14vw] mt-4 w-72 bg-white border rounded-lg shadow-lg p-4 z-50">
          <h3 className="font-semibold mb-3">Frequency Calculator</h3>

          {/* Price unit input */}
          {/* <div className="mb-2">
            <label className="block text-sm mb-1">Price per Unit</label>
            <input
              type="number"
              value={unit}
              onChange={(e) => setUnit(Number(e.target.value))}
              className="border px-2 py-1 w-full rounded"
            />
          </div> */}

          {/* Period selector */}
          <div className="mb-2">
            <label className="block text-sm mb-1">Period</label>
            <select
              value={period}
              onChange={(e) => setPeriod(e.target.value)}
              className="border px-2 py-1 w-full rounded"
            >
              <option value="daily">Daily (×365)</option>
              <option value="weekly">Weekly (×52)</option>
              <option value="monthly">Monthly (×12)</option>
              <option value="yearly">Yearly (×1)</option>
            </select>
          </div>

          {/* How many times */}
          <div className="mb-2">
            <label className="block text-sm mb-1">How many times</label>
            <input
              type="number"
              value={times}
              onChange={(e) => setTimes(e.target.value)}
              className="border px-2 py-1 w-full rounded"
              min={0}
            />
          </div>

          {/* Total budget */}
          <div className="mb-2">
            <label className="block text-sm mb-1">Total</label>
            <input
              type="text"
              value={Math.round(frequency).toLocaleString()}
              readOnly
              className="border px-2 py-1 w-full rounded bg-gray-100"
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-2 mt-3">
            <button
              onClick={() => setOpen(false)}
              className="px-3 py-1 rounded bg-gray-200"
            >
              Cancel
            </button>
            <button
              onClick={updateFrequency}
              className="px-3 py-1 rounded bg-blue-500 text-white"
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
